import { createContext, useContext, useState, ReactNode, SetStateAction, Dispatch } from 'react';
import { PendingUser } from '@/shared/types/controllers/AuthControllerTypes';
type PendingUserContextType = {
  pendingUser: PendingUser | undefined;
  setPendingUser: Dispatch<SetStateAction<PendingUser | undefined>>;
};
const PendingUserContext = createContext<PendingUserContextType | undefined>(undefined);
export const usePendingUserContext = () => {
  const context = useContext(PendingUserContext);
  if (!context) {
    throw new Error('usePendingUser must be used within a PendingUserContextProvider');
  }
  return context;
};
export const PendingUserContextProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [pendingUser, setPendingUser] = useState<PendingUser | undefined>();
  return <PendingUserContext.Provider value={{
    pendingUser,
    setPendingUser
  }} data-sentry-element="unknown" data-sentry-component="PendingUserContextProvider" data-sentry-source-file="PendingUserContextProvider.tsx">
      {children}
    </PendingUserContext.Provider>;
};